<template>
  <div class="language" ref="language">
    <span @click="handleSelect">{{ language }}</span>
    <div class="language-select" :class="{ 'is-active': isSelect }">
      <div
        class="language-select-item"
        v-for="lan in languages"
        :key="lan.value"
        @click.prevent="changeLanguage(lan)"
      >
        {{ lan.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'language',
  components: {},
  props: [],
  data() {
    return {
      isSelect: false,
    }
  },
  watch: {},
  computed: {
    ...mapState(['score', 'language', 'languages', 'language_value']),
  },
  created() {
    this.languages_init()
  },
  getPath() {
    return window.localStorage.getItem('path')
  },
  mounted() {
    this.handleLanguage()
  },
  methods: {
    changeLanguage(v) {
      if (v.value === 'zh' || v.value === 'en' || v.value === 'zh-hk') {
        this.$i18n.locale = v.value
        this.$store.commit('SET_LANGUAGE_VALUE', v.value)
        localStorage.setItem('translate', this.language_value)
      }
      this.$store.commit('SET_LANGUAGE', v.symbol)
      this.isSelect = false
      this.$router.go(0)
    },
    handleSelect() {
      this.isSelect = !this.isSelect
    },
    handleLanguage() {
      switch (localStorage.getItem('translate')) {
        case 'zh':
          this.$store.commit(
            'SET_LANGUAGE',
            this.getLanguagesItem_of_symbol('zh')
          )
          localStorage.setItem(
            'translate',
            this.getLanguagesItem_of_value('zh')
          )
          this.$i18n.locale = localStorage.getItem('translate')
          break
        case 'en':
          this.$store.commit(
            'SET_LANGUAGE',
            this.getLanguagesItem_of_symbol('en')
          )
          localStorage.setItem(
            'translate',
            this.getLanguagesItem_of_value('en')
          )
          this.$i18n.locale = localStorage.getItem('translate')
          break
        case 'zh-hk':
          this.$store.commit(
            'SET_LANGUAGE',
            this.getLanguagesItem_of_symbol('zh-hk')
          )
          localStorage.setItem(
            'translate',
            this.getLanguagesItem_of_value('zh-hk')
          )
          this.$i18n.locale = localStorage.getItem('translate')
          break
      }
      this.$store.commit(
        'SET_LANGUAGE_VALUE',
        localStorage.getItem('translate')
      )
    },
    getLanguagesItem_of_symbol(val) {
      for (let index = 0; index < this.languages.length; index++) {
        if (this.languages[index].value === val) {
          return this.languages[index].symbol
        }
      }
    },
    getLanguagesItem_of_value(val) {
      for (let index = 0; index < this.languages.length; index++) {
        if (this.languages[index].value === val) {
          return this.languages[index].value
        }
      }
    },
    languages_init() {
      if (!localStorage.getItem('translate')) {
        localStorage.setItem('translate', 'zh')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.language {
  width: 2.1vw;
  height: 2.1vw;
  margin-right: 1rem;
  position: absolute;
  top: 1.7rem;
  left: 99rem;
  z-index: 999;
  span {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1vw;
    border-radius: 50%;
    background-color: var(--languyage-box-color);
    color: var(--language-font-color);
    cursor: pointer;
    &:hover {
      color: #fff;
      background-color: #8c413f;
      border-color: #8c413f;
    }
  }
  .language-select {
    position: absolute;
    top: 150%;
    right: 0;
    width: 8vw;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 2px 2px 2px 0px rgba(0, 44, 79, 0.3);
    border-radius: 5px;
    height: 0;
    transition: all 0.3s;
    overflow: hidden;
    z-index: 1;
    &-item {
      text-align: center;
      color: #666666;
      line-height: 2;
      cursor: pointer;
      &:hover {
        color: white;
        background-color: #a63528;
      }
    }
  }
  .is-active {
    height: auto;
  }
}

@media screen and (max-width: 1024px) {
  .language {
    span {
      border: 1px solid;
    }
  }
}
</style>